import { HTMLInputTypeAttribute, forwardRef } from "react";
import { classNames } from "../../../style/common";
import { AllInputProps, InternalInputProps } from "./Common";

const InputBox = forwardRef<HTMLInputElement, AllInputProps<HTMLInputTypeAttribute | undefined> & InternalInputProps>((props: AllInputProps<HTMLInputTypeAttribute | undefined> & InternalInputProps, ref) => {
  const inputStyle = props.inputStyle ?? "filled";

  return (
    <div className={classNames(`flex rounded-md shadow-sm h-[34px]`, props.className)}>
      <div className="relative flex flex-grow items-stretch focus-within:z-10 select-none">
        {
          props.leftAddons && props.leftAddons
        }

        <input
          ref={ref}
          type={props.type}
          value={props.value ?? ""}
          disabled={props.disabled}
          onFocus={(event) => event.currentTarget.select()}
          onWheel={(event) => event.currentTarget.blur()}
          min={props.min}
          max={props.max}
          onKeyDown={props.onKeyDown}
          onBlur={props.onBlur}
          onChange={props.onChange}
          style={{ ...(props.style ? props.style : {}) }}
          className={
            classNames(
              `appearance-none flex-1 block w-full rounded-md bg-secondary text-contrast-primary sm:leading-6 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-calendar-picker-indicator]:opacity-0`,
              inputStyle === "filled" && props.leftAddons ? "rounded-l-none" : "",
              inputStyle === "filled" && props.rightAddons ? "rounded-r-none" : "",
              inputStyle === "filled"
                ? classNames(props.hasValidationErrors
                  ? "border-error-secondary focus:border-error-contrast"
                  : "border-color-border"
                )
                : "",
              inputStyle === "underline"
                ? classNames(
                  "px-[6px] py-0 bg-transparent border-0 border-b-2 rounded-none focus:shadow-none focus:ring-0 text-contrast-primary placeholder:text-contrast-tertiary",
                  props.hasValidationErrors ? "border-b-error-secondary focus:border-b-error-contrast" : "border-b-contrast-primary/20"
                )
                : "",
              inputStyle === "subtle"
                  ? "!bg-secondary/60 text-contrast-tertiary border-none rounded"
                  : "",
              props.disabled ? "cursor-not-allowed text-contrast-tertiary" : ""
            )
          }
          placeholder={props.placeholder}
        />

        {
          props.rightAddons && props.rightAddons
        }
      </div>
    </div>
  )
});

export default InputBox;